export default function damp(targetValue, currentValue) {
  var factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;
  var precision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.01;
  return Math.abs(targetValue - currentValue) < precision ? targetValue : currentValue + (targetValue - currentValue) * factor;
}